/**
 * AdminSectionCard - one card in the AdminLandingPage section grid (12.1).
 *
 * Shape per SPEC §9 AdminLandingPage:
 *   - 3-part FA icon at the top
 *   - Title
 *   - 1-sentence description
 *   - "Open" button linking to the section path
 */
import { Link } from "react-router-dom";

import { Button, Card } from "@/components/ui";

export interface AdminSectionCardProps {
  /** Display title for the section. */
  title: string;
  /** One-line description shown under the title. */
  description: string;
  /**
   * 3-part Font Awesome class string (renders as boxes until FA Pro
   * ships). Example: ``fa-duotone fa-thin fa-users``.
   */
  icon: string;
  /** Destination path for the "Open" button. */
  to: string;
}

export function AdminSectionCard({
  title,
  description,
  icon,
  to,
}: AdminSectionCardProps): JSX.Element {
  return (
    <Card padding="md" className="flex h-full flex-col">
      <div className="flex items-start gap-3">
        <i
          className={`${icon} shrink-0 text-3xl text-primary-600`}
          aria-hidden="true"
        />
        <div className="min-w-0">
          <h3 className="truncate text-base font-semibold text-neutral-900">
            {title}
          </h3>
        </div>
      </div>
      <p className="mt-3 flex-1 text-sm text-neutral-600">{description}</p>
      <div className="mt-4">
        <Link to={to}>
          <Button variant="secondary" size="sm" type="button">
            Open
          </Button>
        </Link>
      </div>
    </Card>
  );
}

export default AdminSectionCard;
